import { GetFacturasFinanciablesDtoProps } from "api/DTOs/GetFacturasFinanciablesDto"
import { formatCurrency } from "common/utils/currency"
import { TFunction } from "i18next"
import { frontendDateFormat } from "utils/formatDate"

export const COLUMNAS_FACTURAS_FINANCIABLES = (t: TFunction) => {
  const columnHeaders = [
    {
      header: t("financiables.columns.numFactura"),
      field: "numero",
      key: "numero",
      sorter: true,
    },
    {
      header: t("financiables.columns.razonSocial"),
      field: "razonSocial",
      key: "razonSocial",
      sorter: true,
    },
    {
      header: t("financiables.columns.nif"),
      field: "nif",
      key: "nif",
      sorter: true,
    },
    {
      header: t("financiables.columns.importe"),
      field: "importe",
      key: "importe",
      bodyClassName: "!tw-text-end",
      alignCol: "right",
      body: ({ importe }: GetFacturasFinanciablesDtoProps) =>
        formatCurrency(importe),
      sorter: true,
    },
    {
      header: t("financiables.columns.fechaEmision"),
      field: "fechaEmision",
      key: "fechaEmision",
      body: ({ fechaEmision }: GetFacturasFinanciablesDtoProps) =>
        fechaEmision ? frontendDateFormat(new Date(fechaEmision)) : "",
      sorter: true,
    },
  ]
  return columnHeaders
}
